import { Button } from 'antd';
import { WatchlistItem as WatchlistItemSchema } from '../../api/watchlist';
import { useWatchListItem } from '../context/watchlist-item-context';
import { DeleteOutlined } from '@ant-design/icons';
import styles from './watchlist.module.scss';
import ButtonGroup from 'antd/es/button/button-group';
import { useState } from 'react';
import { displayCryptoSymbol } from '../../trade/utils/crypto';
import api from '../../api';
import { useWatchList } from '../context/watchlist-context';

export const WatchlistItem = ({
  item,
} :{
  item: WatchlistItemSchema,
}) => {
  const { selectedListId } = useWatchList();

  const { selectItem: select, item: selected } = useWatchListItem();
  const { items } = useWatchList();

  const isSelected = selected?.symbol === item.symbol;
  const [removing, setRemoving] = useState(false);

  const selectItem = () => {
    select(item);
  }

  const removeItem = async () => {
    try {
      setRemoving(true)
      if (selectedListId == null) {
        await api.watchlistV2.deleteDefaultWatchlistItem(item.symbol)
      } else {
        await api.watchlistV2.deleteWatchlistItem(selectedListId, item.symbol);
      }
      items.reload();
    } finally {
      setRemoving(false);
    }
  }

  return <ButtonGroup className={styles.group}>
    <Button
      onClick={selectItem}
      type={isSelected ? 'primary' : 'default'}
      className={styles.selectButton}  
    > 
      {/* displayCryptoSymbol removes USD suffix that crypto usually has */}
      {/* not 100% sure this works for stocks / options / futures  */}
      {/* if it does not work please remove displayCryptoSymbol from here */}
      { displayCryptoSymbol(item.symbol) }
    </Button>
    <Button
      className={styles.removeButton}
      onClick={removeItem}
      loading={removing}
      disabled={removing}
      icon={<DeleteOutlined/>} 
      type='default'
    />
  </ButtonGroup>
}